<div class="flex-box-center flex-box-gap-2">
  <lib-icon class="text-size-20" [ngClass]="data.icon.classes">{{ data.icon.name }}</lib-icon>
  <p class="fw-400 text-size-14">{{ data.message }}</p>
  <lib-icon class="ml-auto c-pointer" (click)="close()">close</lib-icon>
</div>
